<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn" style="color:black;">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div>{{ campaignData.name }} <b-badge class="m-1" variant="success">PUBLISHED</b-badge></div>
        <b-button-group>
          
          <router-link :to="`/campaign/${campaign_type}/edit`" class="link">
            <b-button>
              <span class="link"><i class="fa fa-edit text-primary"></i>&nbsp;Edit</span>
            </b-button>
          </router-link>
          
          <router-link :to="`/campaigns/${campaign_type}`" class="link">      
            <b-button class="custom-close-btn">
              <span class="link"><i class="fa fa-times text-danger"></i>&nbsp;Close</span>
            </b-button>
          </router-link>
              
        </b-button-group>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="9">
            <b-btn v-b-toggle.collapse1 variant="primary">Details</b-btn>
            <b-collapse id="collapse1" class="mt-2">
                <div class="card-text">
                  <table class="table table-bordered table-striped mb-0">
                  <tbody>                           
                    <tr>
                      <td width="20%"><span class="fw-b">Category</span></td>
                      <td>Uncategorized</td>
                    </tr>
                    <tr>
                      <td width="20%"><span class="fw-b">Created by</span></td>
                      <td>Matthews Test User</td>
                    </tr>
                    <tr>
                      <td width="20%"><span class="fw-b">Created on</span></td>
                      <td>June 6, 2019 5:55 pm +07</td>
                    </tr>
                    <tr>
                      <td width="20%"><span class="fw-b">Publish Up</span></td>
                      <td>June 6, 2019 5:55 pm +07</td>
                    </tr>
                    <tr>
                      <td width="20%"><span class="fw-b">Publish Down</span></td>
                      <td>Never</td>
                    </tr>
                    <tr>
                      <td width="20%"><span class="fw-b">ID</span></td>
                      <td>4</td>
                    </tr>
                    <tr>
                      <td width="20%"><span class="fw-b">Wallet segments</span>                                                                   
                      </td>
                        <td>sg_6_productB</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </b-collapse>
            <b-card>
              <div class='camp-stat-header'>
                <div class='statistic-title'><strong><i class="fa fa-bar-chart-o text-primary"></i>&nbsp;Campaing statistics</strong></div>
                <div>
                 <div class="input-group">
                      <div class="input-group-addon">
                        <label class="control-label" for="daterange_date_from">From</label>        
                      </div>
                      <div>
                        <b-form-input type="date" id="publishAt"></b-form-input>
                      </div>                   
                      <div class="input-group-addon" style="border-left: 0;border-right: 0;">
                        <label class="control-label" for="daterange_date_to">To</label>        
                      </div>
                      <div>
                        <b-form-input type="date" id="unpublishAt"></b-form-input>
                      </div>
                      <div class="input-group-btn">
                        <b-button id="custom-apply" block ><i class="fa fa-check"></i>&nbsp;Apply</b-button>                    
                      </div>
                  </div>                 
                </div>
              </div>
              <br>
              <b-row>
                <b-col md="12">
                  <div class="chart-wrapper">
                    <line-chart chartId="campaign-stat-chart"/>
                  </div>
                </b-col>
              </b-row>
            </b-card>
           
            <b-tabs v-model="tabIndex[0]">
              <b-tab active>
                <template slot="title">
                  <i class="icon-calculator"></i> {{tabs[0]}}
                </template>
                <b-col md="12" v-for="item in decisionItems" :key="item.id">
                  <b-row d-flex justify-content-between class='custom-tab-row' >
                    <b-col md="1"><i class="cui-globe icons font-2xl" style="color:#f86c6b"></i></b-col>
                    <b-col md="7"><span class='name-element'>{{item.col1}}</span></b-col>
                    <b-col md="4" class='tab-col-3'>{{item.col2}}</b-col>
                  </b-row>
                </b-col>
               
              </b-tab>
              <b-tab>
                <template slot="title">
                  <i class="icon-people"></i> {{tabs[1]}}
                </template>    
  
                <div class="clients-container" >
                  <div v-for="item in clientsItems" :key="item.id">
                      <div class="card custom-card" >
                        <div style="text-align:center;margin-top:1.25rem"> 
                          <img class="card-img-top" v-bind:src="`img/avatars/${item.avatar}`" alt="Card image cap" style="width: 50%;border-radius: 50%;">
                        </div> 
                        <div class="card-body">
                          <a href="/s/contacts/view/34199" data-toggle="ajax">
                             <h5 class="card-title">120.18.233.208</h5>
                          </a>
                         
                          
                          <div class="text-muted  ">
                            <i class="fa fa-fw fa-building mr-xs"></i>{{item.company}}
                          </div>
                          <div class="text-muted  ">
                            <i class="fa fa-fw fa-map-marker mr-xs"></i>{{item.address}}
                          </div>
                          <div class="text-muted  ">
                            <i class="fa fa-fw fa-globe mr-xs"></i>{{item.country}}
                          </div>                                      
                          <i v-bind:class="`flag-icon flag-icon-${item.countryIcon} h1`"></i>                                           
                        </div>
                      </div>
            
                  </div>
                </div>
               
              </b-tab>
            </b-tabs>
                  
          </b-col>

          <b-col md="3">
            <div class="panel bg-transparent shd-none bdr-rds-0 bdr-w-0 mb-0">
              <div class="panel-heading">
                <div class="panel-title">Recent Activity</div>
              </div>
              <div class="panel-body pt-xs">
                  <ul class="media-list media-list-feed">
                    <li class="media">
                     
                    </li>
                  </ul>
              </div>
              </div>
          </b-col>
        </b-row>

      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import sampleData from './_dataMockup.js';//to simulate the database...
import LineChart from './LineChart';
import Page403 from "@/views/pages/Page403.vue";
import { router } from '@/router/index';
//const axios = require('axios');

const formShape = {
  name: "",
  description: "",
  published : false,
  serial: false,
  category: "",
  PublishAt: null, 
  UnpublishAt: null, 
  CounterfeitCaseRules: null, 
  DuplicateMaxLimit: null, 
  LocationMismatch: null, 
  CounterfeitCaseRuleDuplicateMaxLimit: null, 
  GoogleAnalyticTrackingCode:   null, 
  ChoosePageLoaderIcon:  null, 
  AllowGeolocationMessage:  null, 
}

export default {
  name: "View", //must be the same name than the file (without extension)! 
  components: {
    LineChart,
    Page403
  },
  created: function() {
    console.log('id=',this.$route.params.id);
    
  },
  watch: {
    "$route.params.campaign_type": function(id) {
      this.campaign_type = this.$route.params.campaign_type;
      this.loadCampaign();
    }
  },
  mounted: function(){
    //const userData = this.getUserData(this.$route.params.id);
    this.getPermission();
    if(!this.permission.capabilities.View){
      this.showPage403 = true;
      return;
    }
    document.getElementById('campaign-stat-chart').style.height = '250px';
  },

  data() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let campaign_type = this.$route.params.campaign_type;
    if (window.location.href.includes("/edit")) {
      var campaign_id = localStorage.getItem("page_campaign_id");
    }
    return {
      loginUserInfo: loginUserInfo,
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      campaign_type: campaign_type,
      id: this.$route.params.id,
      campaignData: this.getElementData(1),
      decisionItems: [
        {id:0, col1:'Merino verify code (Code Verify)', col2:'Submit'},
        {id:1, col1:'Verify Code Usage Limit', col2:'Data'},
        {id:2, col1:'Protect Code (URL)', col2:'Data'},
        {id:3, col1:'Business Cards Fake Contactform (Form) ', col2:'Submit'},   
      ],
      clientsItems:[      
        {id:1, name:'182.232.49.118', url:'eferf', avatar:"1.jpg", company:'AIS', address:'Sukhumvit road', city:'Bangkok', countryIcon:'th', country:'Thailand'}, 
        {id:2, name:'183.232.49.118', url:'regerl', avatar:"2.jpg", company:'PTT CL', address:'jkh fwf ', city:'Paris', countryIcon:'fr', country:'France'}, 
        {id:3, name:'184.232.49.118', url:'rul', avatar:"3.jpg", company:'AIS', address:'wewfwef', city:'Sydney', countryIcon:'au', country:'Australia'}, 
        {id:4, name:'185.232.49.118', url:'rul', avatar:"4.jpg", company:'AIS', address:'... .... ..', city:'Bangkok', countryIcon:'jp', country:'Japan'}, 
        {id:5, name:'186.232.49.118', url:'rul', avatar:"5.jpg", company:'AIS', address:'... .... ..', city:'Bangkok', countryIcon:'th', country:'Thailand'}, 
        {id:6, name:'187.232.49.118', url:'rul', avatar:"6.jpg", company:'AIS', address:'... .... ..', city:'Bangkok', countryIcon:'th', country:'Thailand'}, 
        {id:7, name:'188.232.49.118', url:'rul', avatar:"7.jpg", company:'AIS', address:'... .... .. ...', city:'Bangkok', countryIcon:'th', country:'Thailand'}, 
      ],
      tabIndex: [0, 0],
      tabs: [
        'Decisions',
        'Clients',
      ]
    }
  },
 
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName+(this.campaign_type.charAt(0).toUpperCase() + this.campaign_type.slice(1));
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === that.permission.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        }
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    getElementData: function(id) {
      return sampleData[id]; 
    }
  }
}
</script>

<style scoped>
  
  .flag-icon{
    margin-bottom: -5px;
    margin-top: 3px;
    font-size: 2em;
  }
  .clients-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .panel-body{
    display: flex;
    flex-direction: column;
    align-items: that-start;
  }
  .text-muted{
    text-align: left;
  }
  .camp-stat-header{
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
  .form-control{
    border-radius:0;
  }
  .input-group{
    display: flex;
    flex-direction: row;
  }
  .control-label{
    margin-bottom: 0;
    margin-top: 3px;
  }
  .input-group-addon{
    padding: 2px 12px;
    font-weight: normal;
    /* line-height: 1; */
    /* text-align: center; */
    background-color: #e4e7ea;
    border: 1px solid #dadcde;
  }
  .card{
    margin-top: 0.5rem;
    border-radius: 0;
  }
  .custom-card{
    width: 20rem;
    display: flex;
    flex-direction: column;
    margin: 1em;
  }
  .badge {
    padding: 0.4em;
    border-radius: 0;
  }
  .btn.disabled {
    cursor: auto;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn{
    border-radius: 0;
    border: 1px solid #a4acb5;
  }
  .custom-close-btn{
    margin-left:-1px;
  }
  .fw-b{
    font-weight: 600;
  }

  @media only screen and (max-width: 640px) {
    /* .custom-header{
      flex-direction: column;
      align-items: inherit;
    }
    .custom-header > div:first-child {
      margin-bottom: 10px;
    }  */
    .input-group{
      display: flex;
      flex-direction: column;
    }
 
  }

  @media only screen and (max-width: 300px) {
    .custom-header{
      flex-direction: column;
      align-items: inherit;
    }
    .custom-header > div:first-child {
      margin-bottom: 10px;
    } 
    .input-group{
      display: flex;
      flex-direction: column;
    }
  }
  
  @media only screen and (max-width: 1250px) {
    .camp-stat-header{
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
    .statistic-title{
      margin-bottom: 1em;
    }
  }

  @media only screen and (max-width: 1705px) {
     .custom-card{
      width: 15rem;
    }
  }
  
  .tab-col-3{
    color: #b3b3b3;
    font-style: italic;
    display:flex;
    justify-content: flex-end;
  }

  .name-element {
    color: #5c6873;
    font-weight: 600;
  }

  .custom-tab-row {
    border: 1px solid #f0f0f0;
    padding: 5px;
  }

  .client-card{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
</style>

<style>
  .custom-header{
    display: flex;
    justify-content: space-between;
  } 

  #custom-apply{
    border: 1px solid #dadcde;
    border-radius:0;
    border-left: 0;
    background-color: #20a8d8;
    color:white;
  }

  select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
  }

  /* For IE10 */
  select::-ms-expand {
    display: none;
  }
  .link{
    color:black;
    text-decoration: none!important;
  }
</style>